import {
  fetchDataBrainTrendsCommon,
  fetchDataBrainRanksCommon,
} from '@/pages/intelligence/services/topcharts';
import { getDateTypeOfBackend } from '@/pages/intelligence/utils/common';
import {
  RanksResponse,
  TrendsResponse,
} from '@/pages/intelligence/pages/_config/topchartsInterface';
import { sortByTargetMetricList } from '@/pages/intelligence/utils/topchartsUtils';
import * as filterKeyMap from '@intelligence/components/Filter/FilterBase/_config';
import moment from 'moment';
import { formatDateStr } from '@gp/utils/common';

export const handleCommonReqParams = (params: any): any => {
  if (!params) return {};
  const temp = {
    ...params,
    region_type: 'market',
    regions:
      Array.isArray(params.markets) && params.markets.length
        ? params.markets
        : Array.isArray(params.regions) && params.regions.length
        ? params.regions.map((item: string) => item?.toLowerCase())
        : ['global'],
    date_type: getDateTypeOfBackend(params.date_type),
    game_code: params?.game_code?.length ? params?.game_code : [],
    start_date: formatDateStr(params?.start_date),
    end_date: formatDateStr(params?.end_date),
    // moment(create_time).format("YYYY-MM-DD")
  };
  delete temp.markets;
  return temp;
};

export const getTopChartsDataBrainRankList = async (
  params: any,
  config?: { [key: string]: any },
): Promise<RanksResponse> => {
  const ranksRes: RanksResponse = {
    total: 0,
    list: [],
    req: {
      start_date: '',
      end_date: '',
    },
    error: {},
  };
  try {
    const newParams = handleCommonReqParams(params);
    // const res = await (isOgdb ? fetchDataBrainRanks(newParams) : fetchDataBrainRanksCommon(newParams));
    const res = await fetchDataBrainRanksCommon(newParams, config);
    if (res.code !== 0) {
      throw new Error('an error code received in method fetchDataBrainRanks');
    }
    const { rank_list, total } = res.data;
    if (Array.isArray(rank_list)) {
      const totalTemp = Number.parseInt(total);
      ranksRes.total =
        typeof totalTemp === 'number' && !Number.isNaN(totalTemp) ? totalTemp : rank_list.length;

      // 对返回结果rank_list-metric_list按数据源与指标名称重新排序
      const listTemp = rank_list.map((item: any) => {
        return {
          ...item,
          metric_list: sortByTargetMetricList(
            params?.metrics || [],
            params?.data_sources || [],
            item.metric_list,
          ),
        };
      });

      ranksRes.list = listTemp;
    }
    ranksRes.req = {
      ...res.req,
      start_date: res.req.start_date || '',
      end_date: res.req.end_date || '',
    };
  } catch (e) {
    console.error(e);
    ranksRes.total = 0;
    ranksRes.list = [];
    ranksRes.req = {
      date_type: getDateTypeOfBackend(params?.date_type),
      start_date: params?.start_date,
      end_date: params?.end_date,
    };
    ranksRes.error = { code: e?.code, msg: e?.msg };
  }
  return ranksRes;
};

export const getTopChartsDataBrainTrend = async (params: any): Promise<TrendsResponse> => {
  const trendsRes: TrendsResponse = {
    list: [],
    barList: [],
  };
  try {
    const newParams = {
      ...handleCommonReqParams(params),
      data_method: 'date',
    };
    // const res = await (newParams.order_source == 'ogdb' ? fetchDataBrainTrends(newParams) : fetchDataBrainTrendsCommon(newParams));
    const res = await fetchDataBrainTrendsCommon(newParams);
    if (res.code !== 0) {
      throw new Error('an error code received in method fetchDataBrainTrends');
    }
    const { metric_timeline_list, metric_chart_list } = res?.data || {};
    if (Array.isArray(metric_timeline_list)) {
      trendsRes.list = metric_timeline_list;
    }
    if (Array.isArray(metric_chart_list)) {
      trendsRes.barList = metric_chart_list;
    }
  } catch (e) {
    console.error(e);
    trendsRes.list = [];
    trendsRes.barList = [];
  }
  return trendsRes;
};

export const getMobileSensorTowerTagDefaultFetchParams = () => {
  return filterKeyMap.SENSOR_TOWER_TAG_KEYS.reduce((current, next) => {
    return { ...current, [next]: [] };
  }, {});
};
